import { API_ORIGIN } from "../config/env";

/**
 * Build an absolute URL for uploaded media from the API.
 */
export function resolveMediaUrl(path) {
  if (path == null || path === "") return "";
  const s = String(path).trim();
  if (/^(https?:|data:|blob:)/i.test(s)) return s;
  const base = API_ORIGIN.replace(/\/+$/, "");
  const rel = s.startsWith("/") ? s : `/${s}`;
  return `${base}${rel}`;
}
